<div *ngIf="currentView==='QuestionOption'"
     [ngClass]="survey && survey.definitionSections && survey.definitionSections.length ? 'displayStatus' : ''"
     class="simple-scroll flex flex-row justify-center items-start full-grow-no-shrink-no-basis">
  <ul class="action-btn-group">
    <li layout="column">
      <div class="header">Custom Survey Builder</div>
      <div class="content flex flex-col">
        <div>
          Create a custom survey by adding different questions (field types) based on your survey requirements
        </div>
        <img class="m-t-15"
             src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/survey-question-step01.png"
             alt="Custom Survey Builder">
      </div>
      <div class="footer flex flex-row justify-center items-center">
        <button mat-button class="action-button w-p-100 m-t-28" (click)="onAddQuestion()">Add Field</button>
      </div>
    </li>
    <li layout="column">
      <!--     <div class="ribbon ribbon-top-left"><span>Coming Soon</span></div>-->
      <div class="header">Upload Excel Template</div>
      <div class="content flex flex-col">
        <div>
          Upload an existing Excel template which will be converted into a compatible Orbitax Data Survey
        </div>
        <img class="m-t-15"
             src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/survey-question-step02.png"
             alt="Upload Excel Template">
      </div>
      <div class="footer flex flex-row justify-center items-center">
        <button mat-button class="action-button w-p-100 m-t-28" (click)="onUploadExcelTemplate()">Upload Template
        </button>
      </div>

    </li>
    <li layout="column">
      <div class="header">Select ITP Fields</div>
      <div class="content flex flex-col">
        <div>
          Select and include existing fields from your solutions in the International Tax Platform
        </div>
        <img class="m-t-15"
             src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/survey-question-step03.png"
             alt="Select Orbitax Fields">
      </div>
      <div class="footer flex flex-row justify-center items-center">
        <button mat-button class="action-button w-p-100 m-t-35" (click)="importFieldSections()">Select Fields</button>
      </div>
    </li>
  </ul>
</div>

<particle-excel-field-mapping *ngIf="currentView==='ExcelFieldMapping'"
                              [endpointName]="endpointName"
                              [workflow]="workflow"
                              [canEditField]="false"
>

</particle-excel-field-mapping>

<div particleHelpNotes helpNoteId="data-survey-stepup-questions" class="flex flex-col full-grow-no-shrink-no-basis"
     *ngIf="currentView==='SurveyFields'"
>
  <div class="flex flex-row full-grow-no-shrink-no-basis">
    <mat-tab-group class="custom-mat-tab"
                   (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
      <mat-tab *ngFor="let section of survey.definitionSections; let i = index" label="{{section.header}}">
        <ng-template mat-tab-label>
          <div class="custom-tab-header flex flex-row justify-start items-center">
            <div class="flex flex-row justify-start items-center">
              <div class="header">{{section.header}}</div>
              <div class="tool-name">{{section.toolName}}</div>
            </div>
            <!-- For DAC6 We don't need it -->
            <!-- <div class="on-hover">
              <button mat-icon-button class="checklist-actions-button"
                      [matMenuTriggerFor]="checklistActionsMenu">
                <mat-icon class="s-20">more_vert</mat-icon>
              </button>
              <mat-menu #checklistActionsMenu="matMenu">
                <button mat-menu-item (click)="onAddQuestion()">
                  <span>Add Question</span>
                </button>
                <button mat-menu-item (click)="importFieldSections()">
                  <span>Select Fields</span>
                </button>
                <button mat-menu-item (click)="removeSection()">
                  <span>Remove Section</span>
                </button>
              </mat-menu>
            </div> -->
          </div>
        </ng-template>
        <div *ngIf="i === selectedFieldSectionIndex" class="content pos-relative m-30 flex flex-col">
          <div *ngIf="section.config.Editor=='DataSurveyFieldDefinitionSelectorComponent'" class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="section?.config?.ConfigKey"
                                   sortFieldKey="Name"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>


